import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import CommonStructured from "../common-components/CommonStructured";
import { fetchFitnessCentersData } from "../../redux/hygiene-reducers/hygieneSlice";
import FitnessCenterListings from "./FitnessCenterListings";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { getReplace1 } from "../common-data/Conversions";
import BankDetails from "./BankDetails";
import CheckinQr from "./CheckinQr";
import CmnFilters from "../lead-management/common/CmnFilters";
import GymManageTabs from "./gym-manage/GymManageTabs";
import FitnessCenterForm from "./fitness-center-actions/FitnessCenterForm";
import BannerConverUpdateForm from "./banner-and-cover-image/BannerConverUpdateForm";
import UrlUpdateForm from "./url-management/UrlUpdateForm";
import DetailListings from "./detail/DetailListings";
import DeviceIdForm from "./DeviceIdForm";

const FitnessCenterLanding = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    isActive: "",
    selCity: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    status: allFilters.isActive?.value || "",
    city: allFilters.selCity?.label || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const [isDeviceIdModalOpen, setIsDeviceIdModalOpen] = useState(false);
  const [selectedGymData, setSelectedGymData] = useState(null);

  function closeModal() {
    setModValues(iniModvalues);
  }

  const closeDeviceIdModal = () => {
    setIsDeviceIdModalOpen(false);
    setSelectedGymData(null);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function getAllFitnessCenters(filters) {
    dispatch(
      fetchFitnessCentersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleOpenDeviceIdModal = (gymData) => {
    setSelectedGymData(gymData);
    setIsDeviceIdModalOpen(true);
  };

  const handleDeviceIdSuccess = () => {
    getAllFitnessCenters(filters); 
  };

  useEffect(() => {
    getAllFitnessCenters(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      status: allFilters.isActive?.value || "",
      city: allFilters.selCity?.label || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.isActive,
    allFilters.selCity,
  ]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "add" || modValues.modName === "edit" ? (
          <FitnessCenterForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            isEdit={modValues.modName === "edit"}
            closeModal={closeModal}
            callFunction={() => getAllFitnessCenters(filters)}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "update_thumbnail" ||
              modValues.modName === "update_cover_image" ||
              modValues.modName === "update_gmb_url" ||
              modValues.modName === "update_short_url"
                ? "mealsModalContainer addIngModal"
                : ""
                    } ${
          modValues.modName === "all_documents" ||
          modValues.modName === "thumbnail" ||
          modValues.modName === "cover_image" ||
          modValues.modName === "checkin_qr_code" ||
          modValues.modName === "bank_statement" ||
          modValues.modName === "view_details"
            ? "mod-width-50p"
            : ""
        }`}
          >
            <ModalHeadAndClose
              title={`${
                modValues.modName === "checkin_qr_code"
                  ? ""
                  : modValues.rowData?.gym_name
                  ? modValues.rowData.gym_name
                  : getReplace1(modValues.modName)
              }`}
              onClose={closeModal}
            />

            {modValues.modName === "update_thumbnail" ||
            modValues.modName === "update_cover_image" ? (
              <div className="grayLine"></div>
            ) : null}

            {modValues.modName === "all_documents" ||
            modValues.modName === "bank_statement" ? (
              <BankDetails
                modName={modValues.modName}
                rowData={modValues.rowData}
              />
            ) : modValues.modName === "thumbnail" ||
              modValues.modName === "cover_image" ? (
              <div className="discussionModalMessage">
                <img
                  src={modValues.image}
                  alt="profile"
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              </div>
            ) : modValues.modName === "checkin_qr_code" ? (
              <CheckinQr rowData={modValues.rowData} />
            ) : modValues.modName === "manage_gym" ? (
              <GymManageTabs
                rowData={modValues.rowData}
                modName={modValues.modName}
                userInfoData={userInfoData}
                callFunction={() => getAllFitnessCenters(filters)}
              />
            ) : modValues.modName === "update_thumbnail" ||
              modValues.modName === "update_cover_image" ? (
              <BannerConverUpdateForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                callFunction={() => getAllFitnessCenters(filters)}
                closeModal={closeModal}
                modName={
                  modValues.modName === "update_thumbnail"
                    ? "thumbnail"
                    : modValues.modName === "update_cover_image"
                    ? "cover_image"
                    : ""
                }
              />
            ) : modValues.modName === "update_gmb_url" ||
              modValues.modName === "update_short_url" ? (
              <UrlUpdateForm
                rowData={modValues.rowData}
                userInfoData={userInfoData}
                callFunction={() => getAllFitnessCenters(filters)}
                closeModal={() =>
                  setModValues((prevs) => ({ ...prevs, isModOpen: false }))
                }
                modName={modValues.modName}
              />
            ) : modValues.modName === "view_details" ? (
              <DetailListings row={modValues.rowData} />
            ) : null}
          </div>
        )}
      </Modal>

      <DeviceIdForm
        isOpen={isDeviceIdModalOpen}
        onClose={closeDeviceIdModal}
        selectedGymData={selectedGymData}
        userInfoData={userInfoData}
        onSuccess={handleDeviceIdSuccess}
      />

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Fitness Centers"}
            createBtnTxt={isAdmin ? "+ Add New Fitness Center" : null}
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "add",
              }))
            }
            isReload={() => getAllFitnessCenters(filters)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CmnFilters
            from={"fitness-center"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FitnessCenterListings
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            callFunction={() => getAllFitnessCenters(filters)}
            setModValues={setModValues}
            userInfoData={userInfoData}
            onOpenDeviceIdModal={handleOpenDeviceIdModal}
          />
        </Col>
      </Row>
    </>
  );
};

export default FitnessCenterLanding;
